import { render, staticRenderFns } from "./providers-home.vue?vue&type=template&id=ebfa0a64"
import script from "./providers-home.vue?vue&type=script&lang=js"
export * from "./providers-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports